import { render, staticRenderFns } from "./LsIdentifyDialog.vue?vue&type=template&id=2b573c21&scoped=true&"
import script from "./LsIdentifyDialog.vue?vue&type=script&lang=js&"
export * from "./LsIdentifyDialog.vue?vue&type=script&lang=js&"
import style0 from "./LsIdentifyDialog.vue?vue&type=style&index=0&id=2b573c21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b573c21",
  null
  
)

export default component.exports